<div *ngIf="deviceParamGatewayV3OsmosLirisManager">

<form [formGroup]="osmosLirisManagerForm" *ngIf="editable && osmosLirisManagerForm">
    <div class="edit-container-params">
        <h4>{{'FIND_BLE_LIRIS'|translate}}</h4>
        <mat-form-field>
            <input matInput placeholder="{{'NB_DISCOVERY'|translate}} :" formControlName="find_ble_liris_nb_discovery" type="number"
                   (keyup)="setDeviceWithForm()">
        </mat-form-field>
        <mat-form-field>
            <input matInput placeholder="{{'SLEEP_AFTER_DISCOVERY'|translate}}:" formControlName="find_ble_liris_sleep_after_discovery"
                   type="number"
                   (keyup)="setDeviceWithForm()">
        </mat-form-field>
        <mat-form-field>
            <input matInput placeholder="{{'WAIT_CMD'|translate}} :" formControlName="find_ble_liris_wait_cmd" type="number"
                   (keyup)="setDeviceWithForm()">
        </mat-form-field>
        <mat-form-field>
            <input matInput placeholder="{{'MAX_ERR'|translate}} :" formControlName="find_ble_liris_max_err" type="number"
                   (keyup)="setDeviceWithForm()">
        </mat-form-field>
    </div>
    <br/>
    <div class="edit-container-params">
        <h4>{{'DISPLAY'|translate}}</h4>
        <mat-form-field>
            <input matInput placeholder="{{'TRAME_GW_LOG_LEVEL'|translate}} :" formControlName="display" type="number"
                   (keyup)="setDeviceWithForm()">
        </mat-form-field>
    </div>
    <br/>
    <div class="edit-container-params">
        <h4>{{'POST_DATA'|translate}}</h4>
        <mat-form-field>
            <input matInput placeholder="{{'NB_ITEMS'|translate}} :" formControlName="post_data" type="number"
                   (keyup)="setDeviceWithForm()">
        </mat-form-field>
    </div>
</form>

<div *ngIf="!editable" class="read-container-params">
    <h4>{{'FIND_BLE_LIRIS'|translate}}</h4>
    <mat-form-field>
        <input matInput placeholder="{{'NB_DISCOVERY'|translate}} :"
               [value]="deviceParamGatewayV3OsmosLirisManager.find_ble_liris.nb_discovery" [readonly]="true">
    </mat-form-field>
    <mat-form-field>
        <input matInput placeholder="{{'SLEEP_AFTER_DISCOVERY'|translate}}:"
               [value]="deviceParamGatewayV3OsmosLirisManager.find_ble_liris.sleep_after_discovery" [readonly]="true">
    </mat-form-field>
    <mat-form-field>
        <input matInput placeholder="{{'WAIT_CMD'|translate}} :"
               [value]="deviceParamGatewayV3OsmosLirisManager.find_ble_liris.wait_cmd" [readonly]="true">
    </mat-form-field>
    <mat-form-field>
        <input matInput placeholder="{{'MAX_ERR'|translate}} :" [value]="deviceParamGatewayV3OsmosLirisManager.find_ble_liris.max_err"
               [readonly]="true">
    </mat-form-field>
</div>
<div *ngIf="!editable" class="read-container-params">
    <h4>{{'DISPLAY'|translate}}</h4>
    <mat-form-field>
        <input matInput placeholder="{{'TRAME_GW_LOG_LEVEL'|translate}} :" [value]="deviceParamGatewayV3OsmosLirisManager.display.trame"
               [readonly]="true">
    </mat-form-field>
</div>
<div *ngIf="!editable" class="read-container-params">
    <h4>{{'POST_DATA'|translate}}</h4>
    <mat-form-field>
        <input matInput placeholder="{{'NB_ITEMS'|translate}} :" [value]="deviceParamGatewayV3OsmosLirisManager.post_data.nb_items"
               [readonly]="true">
    </mat-form-field>
</div>

</div>
